import { Box, HStack, IconButton, SimpleGrid, Skeleton, Text } from '@chakra-ui/react'
import { IoSearch } from 'react-icons/io5'
import { Link } from 'react-router-dom'

export const GridFieldItem = ({
  label,
  children,
  ekeng,
  hasEkeng,
  ekengPrefix,
  isLoading = false,
  isReady = false,
  to,
  ...props
}) => {
  const additionalColumn = hasEkeng ? 1 : 0

  return (
    <SimpleGrid
      columns={label ? 2 + additionalColumn : 1 + additionalColumn}
      gap="16px"
      minHeight="46px"
      alignItems="center"
      borderBottomWidth="1px"
      borderColor="gray.200"
      _dark={{ borderColor: 'gray.700' }}
      pl="16px"
      pr="8px"
      pt="8px"
      pb="8px"
      position="relative"
      _even={{ bg: 'gray.50', _dark: { bg: 'transparent' } }}
      {...props}
    >
      {label && (
        <Box display="flex" alignItems="center" gap="8px">
          {label}
        </Box>
      )}
      {isLoading || !isReady ? (
        <Skeleton borderRadius={8} height="12px" width="100px" />
      ) : (
        <>
          <HStack justify="space-between" wordBreak="break-all">
            {children || (
              <Text color="gray.400" _dark={{ color: 'gray.600' }}>
                Нет данных
              </Text>
            )}
            {to && (
              <IconButton
                variant="ghost"
                colorPalette="light"
                asChild
                size="sm"
                aria-label="Перейти"
                color="gray.500"
                bg="transparent"
                _hover={{
                  color: 'gray.700',
                  _dark: { color: 'gray.300' },
                }}
              >
                <Link to={to}>
                  <IoSearch />
                </Link>
              </IconButton>
            )}
          </HStack>
          {hasEkeng && (
            <Box wordBreak="break-all">
              {ekeng || (
                <Text color="gray.400" _dark={{ color: 'gray.600' }}>
                  Нет данных
                </Text>
              )}
            </Box>
          )}
        </>
      )}
    </SimpleGrid>
  )
}
